import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";

const BottomNav = () => {
  const location = useLocation();
  const { wishlistCount } = useWishlist();

  const navItems = [
    {
      path: "/",
      label: "Home",
      icon: (isActive) => (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke={isActive ? "white" : "currentColor"}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
    },
    {
      path: "/products",
      label: "Products",
      icon: (isActive) => (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke={isActive ? "white" : "currentColor"}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13V9a7 7 0 0114 0v4M3 13h18"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 17h14a2 2 0 002-2v-2H3v2a2 2 0 002 2z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 17v2a2 2 0 002 2h10a2 2 0 002-2v-2"
          />
          {!isActive && (
            <>
              <circle cx="8" cy="10" r="1" fill="currentColor" />
              <circle cx="12" cy="10" r="1" fill="currentColor" />
              <circle cx="16" cy="10" r="1" fill="currentColor" />
            </>
          )}
        </svg>
      ),
    },
    {
      path: "/categories",
      label: "Categories",
      icon: (isActive) => (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke={isActive ? "white" : "currentColor"}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
      ),
    },
    {
      path: "/wishlist",
      label: "Wishlist",
      icon: (isActive) => (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke={isActive ? "white" : "currentColor"}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      ),
      showBadge: true,
    },
    {
      path: "/account",
      label: "Account",
      icon: (isActive) => (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke={isActive ? "white" : "currentColor"}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      ),
    },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 pb-safe">
      <div className="flex justify-around items-center h-16 px-2 py-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const badgeCount = wishlistCount;
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center flex-1 h-full transition-colors relative"
            >
              <div
                className={`mb-1 p-1 rounded-lg transition-all ${
                  isActive ? "bg-green-600 text-white" : ""
                }`}
              >
                {item.icon(isActive)}
                {item.showBadge && badgeCount > 0 && (
                  <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center badge-pulse">
                    {badgeCount}
                  </span>
                )}
              </div>
              <span
                className={`text-xs font-medium ${
                  isActive ? "font-semibold text-green-600" : "text-gray-600"
                }`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
